import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/img/general/install-app.svg'


const _hoisted_1 = { class: "z-50 select-none fixed bottom-0 flex-col w-full bg-white border-t border-gray-200 flex shadow-md px-6 py-4 rounded-t-2xl overflow-hidden" }
const _hoisted_2 = { class: "flex justify-between w-full items-baseline" }
const _hoisted_3 = { class: "text-lg font-medium mb-2" }
const _hoisted_4 = { class: "p-4 bg-greyLight border border-gray-300 flex rounded" }
const _hoisted_5 = {
  key: 0,
  class: "w-12 h-12 mr-5"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 1,
  class: "w-12 h-12 mr-5 flex justify-center items-center bg-green text-white text-2xl rounded-full"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "text-sm mt-1" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  class: "h-full flex flex-col mt-5"
}
const _hoisted_12 = { class: "mt-3 flex" }
const _hoisted_13 = { class: "flex" }
const _hoisted_14 = { class: "shadow-md w-6 h-6" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "mt-3" }
const _hoisted_17 = { key: 2 }
const _hoisted_18 = { class: "mt-3 flex" }
const _hoisted_19 = { class: "flex" }
const _hoisted_20 = { class: "shadow-md w-6 h-6" }
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "mt-3" }
const _hoisted_23 = {
  key: 3,
  class: "items-center mt-10 flex flex-col text-xl"
}
const _hoisted_24 = { class: "shadow-md w-12 h-12 my-3" }
const _hoisted_25 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_auto_animate = _resolveDirective("auto-animate")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.isInstalled ? "Приложение установлено" : "Установите приложение"), 1),
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hideModal && _ctx.hideModal(...args)))
          }, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("i", { class: "fas fa-times" }, null, -1)
          ]))])
        ]),
        _createElementVNode("div", _hoisted_4, [
          (!_ctx.isInstalled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("img", {
                  class: "rounded",
                  src: require('/assets/logo.png'),
                  alt: ""
                }, null, 8, _hoisted_6)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[5] || (_cache[5] = [
                _createElementVNode("i", { class: "fas fa-check" }, null, -1)
              ]))])),
          _createElementVNode("div", null, [
            (_ctx.appName)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.appName), 1))
              : _createCommentVNode("", true),
            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.windowLocation), 1)
          ])
        ]),
        (_ctx.currentBrowser === 'Yandex')
          ? (_openBlock(), _createElementBlock("section", _hoisted_10, [...(_cache[6] || (_cache[6] = [
              _createElementVNode("div", { class: "mt-5" }, " Установка на Android возможна только с браузера Google Chrome ", -1),
              _createElementVNode("div", { class: "mt-3 flex justify-center" }, [
                _createElementVNode("a", {
                  class: "text-white p-3 rounded-full bg-green",
                  href: "https://play.google.com/store/apps/details?id=com.android.chrome",
                  target: "_blank"
                }, "Открыть Google Chrome")
              ], -1)
            ]))]))
          : (_ctx.isSafari)
            ? (_openBlock(), _createElementBlock("section", _hoisted_11, [
                _cache[12] || (_cache[12] = _createStaticVNode("<div class=\"flex items-center\"><div class=\"mr-3 font-medium\">1.</div><div>Нажать на</div><div class=\"p-1 mx-1 bg-greyLight border border-gray-300 rounded\"><svg xmlns=\"http://www.w3.org/2000/svg\" height=\"20\" viewBox=\"0 0 24 24\" width=\"20\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"></path><path fill=\"#098df9\" d=\"M16 5l-1.42 1.42-1.59-1.59V16h-1.98V4.83L9.42 6.42 8 5l4-4 4 4zm4 5v11c0 1.1-.9 2-2 2H6c-1.11 0-2-.9-2-2V10c0-1.11.89-2 2-2h3v2H6v11h12V10h-3V8h3c1.1 0 2 .89 2 2z\"></path></svg></div><div>панели вкладок (снизу)</div></div><div class=\"flex mt-3\"><div class=\"mr-3 font-medium\">2.</div><div><div>Прокрутите и выберите</div><div class=\"p-1 w-max mt-1 bg-greyLight border border-gray-300 rounded font-medium\"> на экран «Домой» </div></div></div>", 2)),
                _createElementVNode("div", _hoisted_12, [
                  _cache[9] || (_cache[9] = _createElementVNode("div", { class: "mr-3 font-medium" }, "3.", -1)),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_13, [
                      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "mr-3" }, "Откройте приложение", -1)),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("img", {
                          class: "",
                          src: require('/assets/logo.png'),
                          alt: ""
                        }, null, 8, _hoisted_15)
                      ])
                    ]),
                    _cache[8] || (_cache[8] = _createElementVNode("div", null, "с главного экрана", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _cache[11] || (_cache[11] = _createElementVNode("div", { class: "flex justify-center font-medium" }, "Нужна помощь?", -1)),
                  _createElementVNode("div", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleTelegramSupportRequest('Android'))),
                    class: "mt-2 flex flex-col items-center rounded-full bg-[#4593FC] px-4 py-1 text-sm font-medium text-white"
                  }, [...(_cache[10] || (_cache[10] = [
                    _createElementVNode("div", { class: "flex items-center" }, [
                      _createElementVNode("div", { class: "text-2xl" }, [
                        _createElementVNode("i", { class: "fab fa-whatsapp" })
                      ]),
                      _createElementVNode("div", { class: "ml-2 text-base" }, "Написать Whatsapp")
                    ], -1)
                  ]))])
                ])
              ]))
            : (_openBlock(), _createElementBlock("section", _hoisted_17, [
                (!_ctx.isInstalled && _ctx.deferredPrompt)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.sendPrompt && _ctx.sendPrompt(...args))),
                      class: "p-4 bg-greyLight border-dashed border-2 border-gray-300 flex rounded h-48 mt-2 justify-center items-center flex-col cursor-pointer"
                    }, [...(_cache[13] || (_cache[13] = [
                      _createElementVNode("div", { class: "fill-grey" }, null, -1),
                      _createElementVNode("button", { class: "mt-1 px-4 py-5 bg-green flex space-x-2 items-center text-white rounded-full" }, [
                        _createElementVNode("svg", {
                          xmlns: "http://www.w3.org/2000/svg",
                          height: "24",
                          viewBox: "0 96 960 960",
                          width: "24"
                        }, [
                          _createElementVNode("path", {
                            fill: "white",
                            d: "M790 976 644 830l42-43 74 74V680h60v181l74-74 42 43-146 146Zm-650 0q-24 0-42-18t-18-42V236q0-24 18-42t42-18h340l240 240v209H600v351H140Zm300-520h220L440 236v220ZM200 856h400q-4-49-30-90t-68-65l38-68q2-4 1-9t-6-7q-4-2-8.5-1t-6.5 5l-39 70q-20-8-40-12.5t-41-4.5q-21 0-41 4.5T319 691l-39-70q-2-5-6.5-5t-9.5 2l-4 15 38 68q-42 24-68 65t-30 90Zm110-60q-8 0-14-6t-6-14q0-8 6-14t14-6q8 0 14 6t6 14q0 8-6 14t-14 6Zm180 0q-8 0-14-6t-6-14q0-8 6-14t14-6q8 0 14 6t6 14q0 8-6 14t-14 6Z"
                          })
                        ]),
                        _createElementVNode("p", null, "Нажмите, чтобы установить")
                      ], -1)
                    ]))]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _cache[19] || (_cache[19] = _createStaticVNode("<div class=\"flex items-center mt-4\"><div class=\"mr-3 font-medium\">1.</div><div>Нажать на</div><div class=\"px-1 py-px mx-1 bg-greyLight border border-gray-300 rounded\"><i class=\"fas fa-ellipsis-v\"></i></div><p>панели вкладок</p></div><div class=\"mt-1\">(справа верху)</div><div class=\"flex mt-3\"><div class=\"mr-3 font-medium\">2.</div><div><div>Прокрутите и выберите</div><div class=\"p-1 w-max mt-1 bg-greyLight border border-gray-300 rounded items-center flex space-x-2\"><img src=\"" + _imports_0 + "\" class=\"fill-gray-700\" alt=\"\"><p class=\"font-medium\">Установить приложение</p></div></div></div>", 3)),
                      _createElementVNode("div", _hoisted_18, [
                        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "mr-3 font-medium" }, "3.", -1)),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_19, [
                            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "mr-3" }, "Откройте приложение", -1)),
                            _createElementVNode("div", _hoisted_20, [
                              _createElementVNode("img", {
                                class: "",
                                src: require('/assets/logo.png'),
                                alt: ""
                              }, null, 8, _hoisted_21)
                            ])
                          ]),
                          _cache[15] || (_cache[15] = _createElementVNode("div", null, "с главного экрана", -1))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _cache[18] || (_cache[18] = _createElementVNode("div", { class: "flex justify-center font-medium" }, "Нужна помощь?", -1)),
                        _createElementVNode("div", {
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.tgOrWa('Android'))),
                          class: "mt-2 flex flex-col items-center rounded-full bg-[#4593FC] px-4 py-1 text-sm font-medium text-white"
                        }, [...(_cache[17] || (_cache[17] = [
                          _createElementVNode("div", { class: "flex items-center" }, [
                            _createElementVNode("div", { class: "text-2xl" }, [
                              _createElementVNode("i", { class: "fab fa-telegram-plane" })
                            ]),
                            _createElementVNode("div", { class: "ml-2 text-base" }, "Написать в Telegram")
                          ], -1)
                        ]))])
                      ])
                    ], 64))
              ])),
        (_ctx.isInstalled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _cache[20] || (_cache[20] = _createElementVNode("div", null, "Откройте приложение", -1)),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("img", {
                  class: "",
                  src: require('/assets/logo.png'),
                  alt: ""
                }, null, 8, _hoisted_25)
              ]),
              _cache[21] || (_cache[21] = _createElementVNode("div", null, "с главного экрана", -1))
            ]))
          : _createCommentVNode("", true)
      ]),
      _cache[22] || (_cache[22] = _createElementVNode("div", { class: "fixed top-0 left-0 w-full h-full bg-gray-500 opacity-50 z-40" }, null, -1))
    ], 512), [
      [_vShow, _ctx.showApp()]
    ])
  ])), [
    [_directive_auto_animate]
  ])
}